<script lang="ts">
import { navigate } from "svelte-navigator";
import { Answer } from "../Model/Answer";
import type { Question } from "../Model/Question";
import { v4 as v4uuid } from 'uuid';
import { questionsService, answersService, startEndService } from "../services";
import { getCurrentUser } from "../services/session";
import type { User } from "../Model/User";
import { Button } from "sveltestrap";
import { onMount } from "svelte";
import type { StartEnd } from "../Model/StartEnd";

let questions: Question[];
let questionSelect: Question;
let currentUser: User;
let voted: Boolean = false;
let voteOk: Boolean = false;
let voteKo: Boolean = false;
let viewOptions: Boolean = true;
let startEnd: StartEnd[];
let startEndValue: StartEnd;
let dateStart: Date;
let dateEnd: Date;

const selectVote = sessionStorage.getItem('voteId');

const dateNow = new Date();

onMount(async () => {

  startEnd = await startEndService.find();

  startEndValue = startEnd.find(s => s.id == 'start');

  dateStart =  new Date(startEndValue.dateTimeStart);
  dateEnd = new Date(startEndValue.dateTimeStop);

  loadQuestions();
})



async function loadQuestions(){
  if (dateNow > dateStart && dateNow < dateEnd && (startEndValue && startEndValue.status)){
    currentUser = await getCurrentUser();
    const preAnswer = await answersService.findByUser(currentUser.id);

    if (preAnswer) {
      voted = true;
      viewOptions = false;
      return;
    }

    questions = await questionsService.findQuestions();  

    for (let i = 0; i < questions.length; i++) {
      const question = questions[i];
      
      question.info.number = i + 1;
    }
    
    // questions.sort(() => Math.random() - 0.5);

    const selectQuestionVote = questions.find(q => q.alias == selectVote);

    if(selectQuestionVote){
      selectQuestion(selectQuestionVote.id);
      return;
    }

    viewOptions = true;

  }else{
    navigate('/login');
  }
}


async function selectQuestion(questionId){

  if (questionId && currentUser.id) {

    questionSelect = questions.find(q => q.id == questionId)


    const answer = new Answer({
      id: v4uuid(),
      userId: currentUser.id,
      questionId: questionId,
      answerDate: ''
    })

    if (await answersService.saveAnswer(answer)) {
      voteOk = true;
      viewOptions = false;
      return;
    }else{
      navigate('login')
    }

    voteKo = true;
    viewOptions = false;
    
  }

}


</script>

<style lang="scss">

.body-html {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 40px;
    padding-bottom: 40px;
    max-width: 360px;
    margin: auto;
  }


  img{
    width: 100%;
    height: auto;
  }

  .third-number{
    background-color: #FFFFFF;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    margin-left: -25px;
    margin-right: 0px;
    font-size: 30px;
    padding-top: 10px;
  }

  .second-tittle{
    font-size: 25px;
    font-weight: 500;
  }
  .img-icon{
    max-width: 70px;
    margin-bottom: 30px;
  }

  .img-logo{
    max-width: 75%;
    margin: 75px 0 30px 0;
  }

  .box-question{
    display: flex;
    flex-direction: row;
    align-items: center;
    border: 0.5rem solid #CF2F2C;
    background-color: #CF2F2C;
    border-radius: 1rem;
    margin-bottom: 1.5rem;
    height: 100px;

    .third-tittle{
      font-weight: bold;
      margin: auto;
    }
  }
  .tittle-2{
      color: #132F3A !important;
      font-weight: 400;
      line-height : 25px;
  }


  .button-opcion{
    width: 100%;
    height: 150px;
    margin-bottom: 20px;
    color: white;
    font-size: 30px;
  }

  hr{
      color: #FFFFFF;
      max-width: 242px;
      margin: auto;
      opacity: 1;
      margin-bottom: 50px;
      margin-top: 50px;
      height: 1px;
  }

  :global(.result-button){
    background-color: #CF2F2C !important;
    color: #FFFFFF !important;
    margin-top: 10px;
  }

</style>

  <div class="body-html">
    <div class="container">
      <div class="row">
  
        {#if questions && viewOptions}  
          <div class="mb-3 col-12 text-center">
            <h1 class="mb-1 font-tittle">¡Elige tu favorito!</h1>
          </div>
          {#each questions as question }
            <div class="col-12 text-center" on:click={() => selectQuestion(question.id)}>
              <div class="box-question" style="background-color: {question.color}; border-color: {question.color}; color: {question.color}">
                <span class="third-number"> {question.info.number} </span>
                <span class="third-tittle" style="color: {question.textColor}">"{question.name}"</span>
              </div>
            </div>
          {/each}
        {/if}
  
        {#if voteOk}
          <div class="col-12 text-center">
            <img class="img-icon" src="/img/icon-check-red.png" alt="">
          </div>
          <div class="col-12 text-center">
            <h1 class="mb-3 font-tittle">¡Muchas gracias por tu voto!</h1>
            <div class="col-12 text-center">
              <div class="box-question" style="background-color: {questionSelect.color}; border-color: {questionSelect.color}; color: {questionSelect.color}">
                <span class="third-number"> {questionSelect.info.number} </span>
                <span class="third-tittle" style="color: {questionSelect.textColor}">"{questionSelect.name}"</span>
              </div>
            </div>
            <span class="second-tittle mt-3">Consulte la votación en el siguiente enlace:</span><br>
            <Button class="result-button" type="button" size="lg" on:click={() => navigate('/results')}>Resultados</Button>
          </div>
        {/if}
  
        {#if voteKo}
          <div class="col-12 text-center">
            <img class="img-icon" src="/img/Icon-alert-octagon.png" alt="">
          </div>
          <div class="col-12 text-center">
            <h1 class="mb-3 font-tittle">¡Atención!</h1>
            <span class="second-tittle mt-3">Su voto no ha podido ser registrado.</span>
          </div>
        {/if}
  
        {#if voted}
          <div class="col-12 text-center">
            <img class="img-icon" src="/img/Icon-alert-octagon-red.png" alt="">
          </div>
          <div class="col-12 text-center">
            <h1 class="mb-3 font-tittle">¡Atención!</h1>
            <span class="second-tittle mt-3">Ya ha sido emitido un voto con esta cuenta.</span>
          </div>
          <div class="col-12 text-center mt-5">
            <span class="second-tittle mt-3">Consulte la votación en el siguiente enlace:</span><br>
            <Button class="result-button" type="button" size="lg" on:click={() => navigate('/results')}>Resultados</Button>
          </div>
        {/if}
  
        <!-- {#if !viewOptions}
          <div class="col-12 mt-4 text-center">
            <img class="img-logo" src="/img/losrealejos.png" alt="">
          </div>
        {/if} -->

      </div>
    </div>
  </div>
